module.exports = __webpack_public_path__ + "img/smoked-fish.cc087918.png";